export default "__VITE_ASSET__s0TsXmx0__"